export default "__VITE_ASSET__DCGF_6yq__"